import { httpClient } from '../client';
import {
  Service,
  ServiceResponse,
  CreateServiceDTO,
  UpdateServiceDTO,
} from '../../../types/service';
import { logger } from '../../../utils/logger';
import { ApiErrorHandler } from '../error.handler';
import { BaseEndpoint } from './base.endpoint';

class ServiceEndpoints extends BaseEndpoint {
  private static instance: ServiceEndpoints;

  private constructor() {
    super('organisations');
  }

  static getInstance(): ServiceEndpoints {
    if (!ServiceEndpoints.instance) {
      ServiceEndpoints.instance = new ServiceEndpoints();
    }
    return ServiceEndpoints.instance;
  }

  async listServices(organizationId: string): Promise<Service[]> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.get<ServiceResponse>(
        `${this.basePath}/${organizationId}/services`,
        { headers }
      );

      // logger.info('Services fetched successfully');
      return response.data.data;
    } catch (error) {
      logger.error('Failed to fetch services:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async createService(organizationId: string, data: CreateServiceDTO): Promise<Service> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.post<{ data: Service }>(
        `${this.basePath}/${organizationId}/services`,
        data,
        { headers }
      );

      logger.info('Service created successfully');
      return response.data.data;
    } catch (error) {
      logger.error('Failed to create service:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async updateService(
    organizationId: string,
    serviceId: number,
    data: UpdateServiceDTO
  ): Promise<Service> {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.put<{ data: Service }>(
        `${this.basePath}/${organizationId}/services/${serviceId}`,
        data,
        { headers }
      );

      logger.info('Service updated successfully');
      return response.data.data;
    } catch (error) {
      logger.error('Failed to update service:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async deleteService(organizationId: string, serviceId: number): Promise<void> {
    try {
      const headers = await this.getAuthHeaders();
      await httpClient.delete(`${this.basePath}/${organizationId}/services/${serviceId}`, {
        headers,
      });

      logger.info('Service deleted successfully');
    } catch (error) {
      logger.error('Failed to delete service:', error);
      return ApiErrorHandler.handle(error);
    }
  }
}

export const serviceEndpoints = ServiceEndpoints.getInstance();
